<template>
  <div class="api-user-create-token">
    <Loading
      class="vasion-loading-indicator"
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="api-user-create-token-form-container">
      <h1 class="api-user-create-token-form-title">Create API User Token</h1>
      <VasionInput
        v-model="form.name"
        :autoFocus="true"
        title="Token Name"
        class="input-style"
        inputType="top-white"
        required
      />
      <VasionDateTimeField
        v-model="form.expirationDate"
        label="Expiration Date"
        type="date"
      />
      <div class="button-group-01">
        <VasionButton
          classProp="secondary"
          @vasionButtonClicked="backToAPITokens()"
        >
          Back to API Tokens
        </VasionButton>
        <VasionButton
          classProp="secondary"
          @vasionButtonClicked="cancelApiUserTokenCreation()"
        >
          CANCEL
        </VasionButton>
        <VasionButton
          classProp="primary"
          @vasionButtonClicked="saveApiUserToken()"
        >
          CREATE
        </VasionButton>
      </div>
    </div>
    <VasionSnackbar
      id="snackbar-config-api-user"
      ref="snackbarConfigAPIUser"
      :showSnackbarBool.sync="showSnackbar"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'APIUserCreateToken',
  components: {
    Loading,
  },
  props: {
    apiUser: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data: function () {
    return {
      form: {
        name: '',
        expirationDate: '',
      },
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      showSnackbar: false,
      snackbarImage: false,
      snackbarSubTitle: '',
      snackbarTitle: '',
    }
  },
  computed: {
    isApiUserValid() {
      return Object.keys(this.apiUser).length > 0
    },
  },
  async created() {
    if (!this.isApiUserValid) this.$emit('cancel')
  },
  mounted: async function () {},
  methods: {
    backToAPITokens() {
      this.$emit('back-to-api-tokens')
    },
    cancelApiUserTokenCreation() {
      this.$emit('cancel')
    },
    async saveApiUserToken() {
      this.isLoading = true

      const isConfigValid = await this.validateApiUserConfig()
      if (!isConfigValid) {
        this.isLoading = false
        return
      }

      const payload = {
        userId: this.apiUser.userID,
        name: this.form.name,
        expiryDate: this.form.expirationDate,
      }

      const saveResult = await this.$store.dispatch(
        'security/createApiUserToken',
        payload
      )

      this.isLoading = false
      if (saveResult?.ResultMessage) {
        this.snackbarTitle = 'Error Creating API User Token'
        this.snackbarSubTitle = saveResult.ResultMessage
        this.snackbarImage = false
        this.showSnackbar = true
      } else if (!saveResult || !saveResult?.Data) {
        this.snackbarTitle = 'Error Creating API User Token'
        this.snackbarSubTitle = 'Unable to create an API User Token.'
        this.snackbarImage = false
        this.showSnackbar = true
      } else {
        this.snackbarTitle = 'API User Token Created Successfully'
        this.snackbarSubTitle = ''
        this.snackbarImage = true
        this.showSnackbar = true

        await new Promise(resolve => setTimeout(resolve, 1500))
        this.$emit('open-token', saveResult.Data.Token)
      }
    },
    async validateApiUserConfig() {
      const validationRules = [
        {
          condition: this.form.name === '',
          message: 'Token Name is required',
        },
        {
          condition: this.form.name.includes(' '),
          message: 'Token Name cannot contain blank spaces',
        },
      ]

      for (const rule of validationRules) {
        if (rule.condition) {
          this.showSnackbarWithMessage(rule.message)
          return false
        }
      }

      this.$refs.snackbarConfigAPIUser.closeSnackbar()
      return true
    },
    showSnackbarWithMessage(message) {
      this.snackbarTitle = 'API User Token Configuration'
      this.snackbarSubTitle = message
      this.snackbarImage = false
      this.showSnackbar = true
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import '@/assets/css/light-theme-system-palette.scss';

.api-user-create-token {
  position: relative;
}

::v-deep .vasion-loading-indicator {
  height: unset;
}

.api-user-create-token-form-container {
  min-width: 390px;
  width: 581px;
  max-width: 581px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.api-user-create-token-form-container > * {
  width: 100%;
}

.api-user-create-token-form-title {
  text-align: center;
  text-transform: capitalize;
  color: $on-surface-variant;
  font-family: $font-family-book;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  margin: 0px;
}
</style>
